import { render, staticRenderFns } from "./AlignRightIcon.vue?vue&type=template&id=6b18c030"
import script from "./AlignRightIcon.vue?vue&type=script&lang=js"
export * from "./AlignRightIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports